module.exports = __webpack_public_path__ + "assets/caozuo.33478a05d43854532d90519333012653.png";